export default __webpack_public_path__ + "static/media/TV6.3e7a81f5.png";